"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const moment_1 = __importDefault(require("moment"));
const react_countdown_1 = require("react-countdown");
const i18next_1 = __importDefault(require("i18next"));
const components_1 = require("@/common/components");
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const styled_1 = __importDefault(require("@emotion/styled"));
const CartOrder_1 = require("@/room/room_view/DetailTabs/CartOrder");
function default_1({ expand, orderPending, submitFn, countdownRenderProps: { days, hours, minutes, seconds, milliseconds, completed }, }) {
    const salesClosed = (0, react_redux_1.useSelector)((state) => state.roomData.salesClosed);
    const isDemandSurvey = (0, react_redux_1.useSelector)((state) => state.isDemandSurvey);
    const startDate = (0, react_redux_1.useSelector)((state) => state.roomData.start_date);
    const formattedStartDate = (0, moment_1.default)(startDate).format('YYYY-MM-DD, HH:mm ');
    const isFolded = !expand;
    if (salesClosed) {
        return ((0, jsx_runtime_1.jsx)(components_1.MapleStoryButton, Object.assign({ isClosed: true }, { children: i18next_1.default.t(isDemandSurvey ? '수요조사 종료' : '판매종료') })));
    }
    else if (completed) {
        return ((0, jsx_runtime_1.jsx)(components_1.MapleStoryButton, Object.assign({ onClick: submitFn, disabled: orderPending, isDemandSurvey: isDemandSurvey }, { children: orderPending ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 24, color: "inherit", thickness: 8 })) : isDemandSurvey ? ((0, jsx_runtime_1.jsx)("span", { children: i18next_1.default.t('다음') })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isFolded && (0, jsx_runtime_1.jsx)(CartOrder_1.CartTotal, {}), (0, jsx_runtime_1.jsx)("span", { children: i18next_1.default.t('구매하기') })] })) })));
    }
    else {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.MapleStoryButton, Object.assign({ disabled: true, isDemandSurvey: isDemandSurvey }, { children: isDemandSurvey ? ((0, jsx_runtime_1.jsx)("span", { children: i18next_1.default.t('다음') })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isFolded && (0, jsx_runtime_1.jsx)(CartOrder_1.CartTotal, {}), (0, jsx_runtime_1.jsx)("span", { children: i18next_1.default.t('구매하기') })] })) })), (0, jsx_runtime_1.jsxs)(CountdownDiv, Object.assign({ style: { borderRadius: '12px' } }, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [formattedStartDate, i18next_1.default.t('오픈')] }), (0, jsx_runtime_1.jsx)("div", Object.assign({ translate: "no" }, { children: (0, jsx_runtime_1.jsx)("div", { children: `${(0, react_countdown_1.zeroPad)(days)}일 ${(0, react_countdown_1.zeroPad)(hours)}:${(0, react_countdown_1.zeroPad)(minutes)}:${(0, react_countdown_1.zeroPad)(seconds)}.${Math.floor(milliseconds / 100)}` }) }))] }))] }));
    }
}
exports.default = default_1;
const CountdownDiv = styled_1.default.div `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 6px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  backdrop-filter: blur(15px);
  > div:first-of-type {
    font-size: 12px;
  }
  > div:last-of-type {
    width: 50%;
    margin-left: 50%;
    > div {
      font-size: 16px;
      font-weight: 700;
      transform: translateX(-61px);
    }
  }
`;
